import React from "react";
import {useEffect, useState} from "react";
import {Image} from "react-bootstrap";
import {useSelector} from "react-redux";
import {userDataSelector} from "../../Redux/Slices/userDataSlice";

export function ProfilePicture({ tempImgUrl, userId }: { tempImgUrl?: string | null; userId?: number }) {
    const [profileImgUrl, setProfileImgUrl] = useState("/images/profile.png");
    const userData = useSelector(userDataSelector);

    useEffect(() => {
        if (tempImgUrl) {
            setProfileImgUrl(tempImgUrl);
        }
        else if (userId && userId != 0) // This case is used for the public profiles
        {
            setProfileImgUrl(
                "https://orbofiprofileimages.s3.ap-southeast-1.amazonaws.com/" +
                userId +
                "/" +
                userId
            );
        }
        else if (userData?.ProfilePicture === "AWS") // The user uploaded their image
        {
            setProfileImgUrl(
                "https://orbofiprofileimages.s3.ap-southeast-1.amazonaws.com/" +
                userData?.UserId +
                "/" +
                userData?.UserId
            );
        }
        else if (userData?.ProfilePicture) // Getting the image from an Oauth service upon user registration
        {
            setProfileImgUrl(userData?.ProfilePicture);
        }
        else // Default case
        {
            setProfileImgUrl("/images/profile.png");
        }
    }, [userData?.ProfilePicture, tempImgUrl, userId]);

    return <Image src={profileImgUrl} className="w-100 h-100" />;
}